import React, {Component} from "react";
import {I18n} from "../../../../I18n/components/loan";
import {SUPER_ADMIN, USER_ROLES} from "../../../../helpers/constants";
import {Alert, Card, CardBody, CardTitle} from "reactstrap";
import {closeAlert} from "../../../../actions/commonsActions";
import {goBack, push} from "connected-react-router";
import {connect} from "react-redux";
import LoanSummaryPropertyList from "./LoanSummaryPropertyList";
import {fetchLoanSummaryProps} from "../../../../actions/loan/loanSummaryPropertyActions";
import CompanySelect from "../../../Company/CompanySelect";
import {isLoansPermission} from "../../../../helpers/companyService";
import swal from "sweetalert";

class LoanSummaryProps extends Component {

    constructor(props) {
        super(props);
        this.state = {
            retailerId: null,
        };
    }

    componentDidMount() {
        (async () => {
            const {authority, company, lang} = this.props;

            if (!isLoansPermission(company, authority)) {
                await swal(I18n[lang].contactUsToAccessThis, '', 'error')
                    .then(() => this.props.goBack())
                return;
            }

            if (authority !== SUPER_ADMIN) {
                await this.setState({
                    retailerId: company.id
                }, async () => await this.fetchData());
            }
        })();
    }

    fetchData = async () => {
        const {retailerId} = this.state;
        await this.props.fetchSummaryProps(retailerId);
    };

    chooseRetailer = event => {
        this.setState({
            retailerId: event.target.value
        }, () => this.fetchData());
    }

    onListItemClick = bankIntegration => {
        this.props.changeLocation({
            pathname: `/dashboard/loan/settings/${bankIntegration}`,
            state: {
                retailerId: this.state.retailerId,
            }
        })
    }

    render() {
        const {authority, lang, loading, companies, summaryProps} = this.props;
        const {retailerId} = this.state;

        const needToChooseRetailer = authority === SUPER_ADMIN && retailerId == null;

        const propertyList = loading
            ? <div className="loading">Loading...</div>
            : <LoanSummaryPropertyList
                lang={lang}
                summaryProps={summaryProps}
                onItemClick={this.onListItemClick}
            />

        return (
            <div>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-settings mr-2"/>
                            {I18n[lang].loans + " / " + I18n[lang].settings}
                        </div>
                    </CardTitle>

                    {
                        needToChooseRetailer ? (
                            <CompanySelect
                                className="promoter-search-filter m-3"
                                lang={lang}
                                companyId={retailerId}
                                companies={companies}
                                onCompanyChange={this.chooseRetailer}
                            />) : null
                    }

                    <CardBody>
                        {needToChooseRetailer
                            ? I18n[lang].chooseCompany
                            : propertyList}
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchSummaryProps: retailerId => dispatch(fetchLoanSummaryProps(retailerId)),
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: url => dispatch(push(url)),
        goBack: () => dispatch(goBack()),
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    summaryProps: state.loanSummaryProps.loanSummaryProps,
    loading: state.loanSummaryProps.loading,
    authority: state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    companies: state.companiesReducer.companies,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(LoanSummaryProps);


// WEBPACK FOOTER //
// ./src/components/Loan/Property/Summary/LoanSummaryProps.js